export default __webpack_public_path__ + "static/media/SDM A.fbb8643f.png";